
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface DesktopNavigationProps {
  isAdmin: boolean;
  onSignUpClick: () => void;
  onAdminDashboardClick: () => void;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({ 
  isAdmin,
  onSignUpClick,
  onAdminDashboardClick
}) => {
  return (
    <nav className="hidden md:flex items-center space-x-6">
      <Link to="/" className="rounded text-foreground hover:text-elfGreen-ink font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700">
        Home
      </Link>
      <Link to="/elf-letter-generator/" className="rounded text-foreground hover:text-elfGreen-ink font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700">
        Free Elf Letter Generator
      </Link>
      <Link to="/blog/" className="rounded text-foreground hover:text-elfGreen-ink font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700">
        Blog
      </Link>
      <Link to="/about/" className="rounded text-foreground hover:text-elfGreen-ink font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700">
        About Us
      </Link>
      {isAdmin ? (
        <Button 
          className="bg-elfGreen-ink hover:bg-[#1b422c] text-white focus-visible:ring-slate-700 font-semibold rounded-xl transition-colors duration-300"
          onClick={onAdminDashboardClick}
        >
          Admin Dashboard
        </Button>
      ) : (
        <Button 
          className="bg-elfRed-ink hover:bg-[#892638] text-white focus-visible:ring-slate-700 font-semibold rounded-xl transition-colors duration-300"
          onClick={onSignUpClick}
        >
          Sign Up
        </Button>
      )}
    </nav>
  );
};

export default DesktopNavigation;
